import { multiply, volatileSum, zero } from "~/utils/PriceUtils";
import type { ResolvedGroupedCartEntry } from "~/features/cart/cart/models/CartData";
import { isTariffSurchargeEnabled } from "~/features/cart/cart/utils/cartUtils";
import type { CartEntrySummaryViewModel } from "~/features/cart/cartV2/models/ProductTableViewModel";

export function buildCartEntrySummary(
  entry: Pick<ResolvedGroupedCartEntry, "cartEntry" | "packGroups">,
): CartEntrySummaryViewModel {
  const lineItems = entry.packGroups.flatMap((group) => group.packEntries);
  const lineItemCount = lineItems.length;
  const totalQuantity = lineItems.reduce((sum, item) => sum + item.quantity, 0);
  const subtotal =
    lineItems.length > 0
      ? volatileSum(...lineItems.map((lineItem) => multiply(lineItem.netPrice ?? zero(), lineItem.quantity)))
      : null;
  const surchargeEnabled = isTariffSurchargeEnabled();

  return {
    totalQuantity,
    lineItemCount,
    subtotal,
    hasTariffSurcharge: surchargeEnabled && lineItems.some((lineItem) => !!lineItem.netPrice?.tariffSurcharge),
    hasIncludedSurcharge: surchargeEnabled && lineItems.some((lineItem) => (lineItem.netPrice?.surcharge ?? 0) > 0),
    canDeleteProduct: entry.cartEntry.packEntryIds.length <= 1,
  };
}
